(function ($) {
  "use strict";

  // sticky header
  var lastScrollTop = 0;
  $(window).scroll(function() {
    var scroll = $(this).scrollTop();
    if (scroll > lastScrollTop) {
        $('.header-kaj').addClass('sticky-down');
        $('.header-kaj').removeClass('sticky-up');
    } else {
      if (lastScrollTop <= 100) {
        $('.header-kaj').removeClass('sticky');
        $('.header-kaj').removeClass('sticky-down');
        $('.header-kaj').removeClass('sticky-up');
      } else {
        $('.header-kaj').addClass('sticky');
        $('.header-kaj').removeClass('sticky-down');
        $('.header-kaj').addClass('sticky-up');
      }
    }
    lastScrollTop = scroll;
  });

  // megamenu
  $('.megamenu-li').parent('ul').addClass('mega-menu');
  $('.menu-banner').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('ul').addClass('sub-menu');

  $("button.navbar-toggler").click(function(){
    $(".main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden-bd");
  });
  $(".close-box").click(function(){
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden-bd");
  });
  $(".mm-fullscreen-bg").click(function(){
    $(".filter-sidebar").removeClass("active");
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden-bd");
  });

  // filter button js
  $("button.filter-button").on('click', function() {
    $(".filter-sidebar").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
  });
  $("button.close-filter-sidebar").on('click', function() {
    $(".filter-sidebar").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
  });

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })

  // product-img full-view & magnific popup
  $('.full-view, .zoom').on('click', function() {
    $('.product_img_top').magnificPopup({
      delegate: 'a',
      type:'image',
      showCloseBtn: true,
      closeBtnInside: false,
      midClick: true,
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1]
      }
    }).magnificPopup('open');
  });

  // back to top
  $(window).scroll(function(){
    if ($(this).scrollTop() > 1000) {
      $('#top').fadeIn();
    } else {
      $('#top').fadeOut();
    }
  });
  $('#top').click(function(){
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

})(jQuery);